import { render, staticRenderFns } from "./FormCategory.vue?vue&type=template&id=6a64ebab&scoped=true&"
import script from "./FormCategory.vue?vue&type=script&lang=js&"
export * from "./FormCategory.vue?vue&type=script&lang=js&"
import style0 from "./FormCategory.vue?vue&type=style&index=0&id=6a64ebab&scoped=true&lang=css&"
import style1 from "./FormCategory.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a64ebab",
  null
  
)

export default component.exports